export default {
    install: (Vue) => {
        Vue.$eventBus = new Vue();

        Vue.axios.interceptors.response.use(response => {
          return response;
        }, async error => {
          // Default for unknown failures (e.g. network/CORS, no response received).
          var message = 'Uh oh, something went wrong!';

          // Surface any backend-provided error message we can find. Strapi typically
          // returns { error: { message, name, status, details } }; pull the most
          // specific message available rather than swallowing it into the generic
          // "Uh oh" banner. This makes form submission failures actionable for
          // end users (see WEL-255).
          if (error.response) {
            var status = error.response.status;
            var data = error.response.data || {};
            var serverMessage = (data.error && data.error.message)
              || data.message
              || (typeof data === 'string' ? data : null);

            if (status === 429) {
              message = "Too Many Requests. Please Wait!";
            } else if (status === 401) {
              message = serverMessage || "Your session has expired. Please log in again.";
            } else if (status === 403) {
              message = serverMessage || "You do not have permission to perform this action.";
            } else if (status === 413) {
              message = "The information you submitted is too large. Please shorten your responses and try again.";
            } else if (serverMessage) {
              message = serverMessage;
            }
          } else if (error.message) {
            message = error.message;
          }

          Vue.$eventBus.$emit('notifyUser', message);
          Vue.$eventBus.$emit('showSending', false);
          return Promise.reject(error);
        });
    }
};